<template>
    <div>
        <div class="modal fade" id="group" tabindex="-1" role="dialog" aria-labelledby="new sale modal" aria-hidden="true">
            <div class="modal-dialog" role="document">
                <div class="modal-content">
                    <div class="modal-header">
                        <template v-if="edit">
                            <h5 class="modal-title">Edit Group</h5>
                        </template>
                        <template v-else>
                            <h5 class="modal-title">New Group</h5>
                        </template>
                        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                            <span aria-hidden="true">&times;</span>
                        </button>
                    </div>
                    <div class="modal-body">
                        <div class="form-group">
                            <label for="sale">Group Name*</label>
                            <input type="text" class="form-control" id="sale" placeholder="Group Name" v-model="name">
                        </div>
                        <div class="form-group">
                            <label>Product Types</label>
                            <v-select multiple v-model="type_model" :options="types" label="description" @input="">
                                <template v-slot:option="type">
                                    <div>
                                        {{ type.description }}
                                    </div>
                                </template>
                            </v-select>
                        </div>
                        <div class="form-group">
                            <label>Products</label>
                            <v-select multiple v-model="product_model" :options="products" label="name" @search="search">
                                <template v-slot:option="product">
                                    <div>
                                        {{ product.name }} ({{ product.ProductType.display }})
                                    </div>
                                </template>
                            </v-select>
                        </div>
                        <div class="form-group">
                            <label>Excluded Products</label>
                            <v-select multiple v-model="excluded_product_model" :options="excluded_products" label="name" @search="excluded_search">
                                <template v-slot:option="excluded_product">
                                    <div>
                                        {{ excluded_product.name }} ({{ excluded_product.ProductType.display }})
                                    </div>
                                </template>
                            </v-select>
                        </div>
                    </div>
                    <div class="modal-footer">
                        <button type="button" class="btn btn-primary" data-dismiss="modal" :class="{'disabled': (name.length < 1)}" @click="save_group()">
                            <template v-if="edit">
                                Save Group
                            </template>
                            <template v-else>
                                Create Group
                            </template>
                        </button>
                        <button type="button" class="btn btn-secondary" data-dismiss="modal">Close</button>
                    </div>
                </div>
            </div>
        </div>
        <loader :loading="loading"></loader>
    </div>
</template> 

<script>

import loader from './loader.vue';
import vSelect from 'vue-select';
import 'vue-select/dist/vue-select.css';
import _ from 'lodash';

export default {

    components: {
        loader,
        vSelect
    },

    props:{
        edit: Boolean,
        groupId: Number,
    },

    data() {
        return {
            loading: true,
            name: '',
            types: [],
            products: [],
            excluded_products: [],
            type_model: null,
            product_model: null,
            excluded_product_model: null,
        };
    },

    mounted(){  
        this.on_load();
        $('#group').on('hidden.bs.modal', function () {
            this.close_modal();
        }.bind(this));
    },

    methods: {
        on_load(){            
            axios.get('/product-types/list')
            .then(function (response) {
                this.types = response.data['product-types'];                
                if(this.edit){
                    this.load_edit();
                } else {
                    $('#group').modal('show');
                    this.loading = false;
                }
            }.bind(this))
            .catch(function (error) {
                // handle error
                alert(error);
                this.loading = false;
            })
        },
        load_edit(){
            axios.get('/groups/' + this.groupId)
            .then(function (response) {
                this.name = response.data.group.name;
                let products = [];
                for(let product in response.data.group.products){
                    products.push(response.data.group.products[product].product)
                }
                let types = [];
                for(let type in response.data.group.product_types){
                    types.push(response.data.group.product_types[type].product_type)
                }
                let excludeds = [];
                for(let excluded in response.data.group.excluded_products){
                    excludeds.push(response.data.group.excluded_products[excluded].product)
                }
                this.product_model = products;
                this.type_model = types;
                this.excluded_product_model = excludeds;
                $('#group').modal('show');
                this.loading = false;
            }.bind(this))
            .catch(function (error) {
                // handle error
                alert(error);
                this.loading = false;
            }.bind(this))
        },
        search(search, loading){
            loading(true); 
            this.get_products(loading, search, this);        
        },
        get_products: _.debounce((loading, search, vm) => {
            axios.get('/products/search?query=' + search)
            .then(function (response) {
                vm.products = response.data.products
                loading(false); 
            }.bind(vm))
            .catch(function (error) {
                // handle error
                alert(error);
                loading(false); 
            })
        },1000),
        excluded_search(search, loading){
            loading(true); 
            this.get_excluded_products(loading, search, this);        
        },
        get_excluded_products: _.debounce((loading, search, vm) => {
            axios.get('/products/search?query=' + search)
            .then(function (response) {
                vm.excluded_products = response.data.products
                loading(false); 
            }.bind(vm))
            .catch(function (error) {
                // handle error
                alert(error);
                loading(false); 
            })
        },1000),
        save_group(){
            let product_ids = [];
            let product_type_ids = [];
            let excluded_product_ids = [];
            for(let product in this.product_model){
                product_ids.push(this.product_model[product].id);
            }
            for(let type in this.type_model){
                product_type_ids.push(this.type_model[type].id);
            }
            for(let excluded in this.excluded_product_model){
                excluded_product_ids.push(this.excluded_product_model[excluded].id);
            }
            if(this.edit){
                axios.patch('/groups/' + this.groupId, 
                {
                    name: this.name, 
                    product_id: product_ids,
                    product_type_id: product_type_ids,
                    product_type_id: product_type_ids,
                    excluded_product_id: excluded_product_ids,
                })
                .then(function (response) {
                    this.close_modal()
                }.bind(this))
                .catch(function (error) {
                }.bind(this))
            } else {
                axios.post('/groups', 
                {
                    name: this.name, 
                    product_id: product_ids,
                    product_type_id: product_type_ids,
                    excluded_product_id: excluded_product_ids,
                })
                .then(function (response) {
                    this.close_modal()
                }.bind(this))
                .catch(function (error) {
                }.bind(this))
            }
        },
        close_modal(){
           this.$emit('closeModal', false); 
        }
    },
};
</script>